import React from "react"
import { Link } from "gatsby"
import {FreelancerIcon} from "../icons/freelancer-icon"

const LinkedIn = ({ size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="stroke-current fill-current h-10 w-10"
  >
    <path d="M22.23 0H1.77C.8 0 0 .77 0 1.72v20.56C0 23.23.8 24 1.77 24h20.46c.98 0 1.77-.77 1.77-1.72V1.72C24 .77 23.2 0 22.23 0zM7.27 20.1H3.65V9.24h3.62V20.1zM5.47 7.76h-.03c-1.22 0-2-.83-2-1.87 0-1.06.8-1.87 2.05-1.87 1.24 0 2 .8 2.02 1.87 0 1.04-.78 1.87-2.05 1.87zM20.34 20.1h-3.63v-5.8c0-1.45-.52-2.45-1.83-2.45-1 0-1.6.67-1.87 1.32-.1.23-.11.55-.11.88v6.05H9.28s.05-9.82 0-10.84h3.63v1.54a3.6 3.6 0 0 1 3.26-1.8c2.39 0 4.18 1.56 4.18 4.89v6.21z" />
  </svg>
)

const Twitter = ({ size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="stroke-current fill-current h-10 w-10"
  >
    <path d="M24 4.37a9.6 9.6 0 0 1-2.83.8 5.04 5.04 0 0 0 2.17-2.8c-.95.58-2 1-3.13 1.22A4.86 4.86 0 0 0 16.61 2a4.99 4.99 0 0 0-4.79 6.2A13.87 13.87 0 0 1 1.67 2.92 5.12 5.12 0 0 0 3.2 9.67a4.82 4.82 0 0 1-2.23-.64v.07c0 2.44 1.7 4.48 3.95 4.95a4.84 4.84 0 0 1-2.22.08c.63 2.01 2.45 3.47 4.6 3.51A9.72 9.72 0 0 1 0 19.74 13.68 13.68 0 0 0 7.55 22c9.06 0 14-7.7 14-14.37v-.65c.96-.71 1.79-1.6 2.45-2.61z" />
  </svg>
)

const GitHub = ({}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="stroke-current fill-current h-12 w-12"
  >
    <path d="M10.9 2.1c-4.6.5-8.3 4.2-8.8 8.7-.5 4.7 2.2 8.9 6.3 10.5.3.1.6-.1.6-.5v-1.6s-.4.1-.9.1c-1.4 0-2-1.2-2.1-1.9-.1-.4-.3-.7-.6-1-.3-.1-.4-.1-.4-.2 0-.2.3-.2.4-.2.6 0 1.1.7 1.3 1 .5.8 1.1 1 1.4 1 .4 0 .7-.1.9-.2.1-.7.4-1.4 1-1.8-2.3-.5-4-1.8-4-4 0-1.1.5-2.2 1.2-3-.1-.2-.2-.7-.2-1.4 0-.4 0-1 .3-1.6 0 0 1.4 0 2.8 1.3.5-.2 1.2-.3 1.9-.3s1.4.1 2 .3C15.3 6 16.8 6 16.8 6c.2.6.2 1.2.2 1.6 0 .8-.1 1.2-.2 1.4.7.8 1.2 1.8 1.2 3 0 2.2-1.7 3.5-4 4 .6.5 1 1.4 1 2.3v2.6c0 .3.3.6.7.5 3.7-1.5 6.3-5.1 6.3-9.3 0-6-5.1-10.7-11.1-10z" />
  </svg>
)

const ContactComponent = () => {
  const currentUrl = typeof window !== "undefined" ? window.location.pathname : ""
  return (
    <div className={`${currentUrl !== "/contact" ? "block absolute -top-32 inset-x-0" : "hidden"}`}>
      <div
        className="grid grid-cols-1 lg:grid-cols-12 gap-4  w-full max-w-3xl px-4 py-8 mx-auto rounded-lg shadow-2xl lg:text-left lg:block bg-gradient-to-br from-purple-300 via-indigo-200 to-teal-200 dark:from-gray-700 dark:via-gray-900 dark:to-black background-animate sm:px-2 md:pb-0 md:pt-12 lg:px-12 lg:py-12">
          <div className="lg:col-span-3 mt-4">
            <h2
              className="font-body2  font-extrabold tracking-tight text-quarternary text-xl sm:text-2xl md:text-3xl lg:my-0 xl:text-4xl sm:leading-tight">
                Interested in working <span className="inline-block text-accent ">together</span> ?
            </h2>
            <p className="font-body2 mt-1 mb-2 text-sm sm:text-md md:text-lg lg:text-xl font-medium text-secondary-text uppercase xl:tracking-wider lg:mb-0">
              Let&lsquo;s build something.</p>
          </div>
          
          <div className="lg:col-span-2 lg:mt-4 lg:mb-0">
            <Link to="/contact"
                className="inline-flex items-center justify-center w-auto font-bold text-sm sm:text-md md:text-lg lg:text-xl cursor-pointer shadow-xl shadow-blue-500/30 dark:shadow-teal-100/20 rounded-full transition duration-300 ease-in-out transform hover:-translate-y-1 bg-gradient-to-r from-sky-400 to-blue-500 hover:from-sky-300 hover:to-blue-400 dark:from-rose-100 dark:to-teal-100 dark:hover:from-rose-50 dark:hover:to-teal-50">
                <div class="flex flex-cols-1">
                  <span className="relative flex items-center justify-center w-full h-full whitespace-nowrap text-primary px-4 py-2 space-x-2 md:px-6 md:py-4 md:space-x-3">Get in touch</span>
              </div>   
            </Link>
          </div>
          <div className="w-1/2 h-1/2">
            {/* <FreelancerIcon /> */}
          </div>
          {/* <div className="flex justify-start items-start md:mt-10 md:mb-5">
            <div className="flex-shrink">
              <a
                href="https://github.com/dehanz13"
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="justify-center items-center">
                  <GitHub />
                </span>
              </a>
            </div>
            <div className="mx-8 flex-shrink">
              <a
                href="https://twitter.com/dehanz13"
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="text-sky-400">
                  <Twitter />
                </span>
              </a>
            </div>

            <div className="flex-shrink bg-white">
              <a
                href="https://www.linkedin.com/in/dannielhansel/"
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="text-blue-900 ">
                  <LinkedIn />
                </span>
              </a>
            </div>
          </div> */}
          {/* <div className="bottom-0 right-0 mb-0 mr-3 lg:absolute lg:-mb-12">
              <img src="https://cdn.devdojo.com/images/september2020/cta-1.png"
                  className="max-w-xs mb-4 opacity-75 sm:max-w-sm md:max-w-xl lg:max-w-lg xl:mb-0 xl:max-w-md" />
          </div> */}
      </div>
    </div>
  )
}

export default ContactComponent
